// extracted by mini-css-extract-plugin
export default {"runnerStatusLabel":"styles_runnerStatusLabel__-d2ZP"};